import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { LoggerService } from '../../common/common.module'
import { LocationCreateEditController } from './locations-create-edit.directive.controller'
import { LOCATION_SERVICE_NAME, LocationService } from '../../../services/location'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'

//#region Asset Imports

import * as TEMPLATE from './locations-create-edit.tpl.html'

//#endregion

// #region Setup

export class LocationsCreateEditDirective
    implements ng.IDirective
{
    restrict = 'E'

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'logger', USER_SESSION_SERVICE_NAME, LOCATION_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        userSession: UserSessionService,
        locationService: LocationService
    ) => new LocationCreateEditController(
        $scope,
        $q,
        $timeout,
        logger,
        userSession,
        LocationService.REFERENCE_TYPE,
        LocationService.SIMAX_MODULE_NAME,
        locationService
    )]

    template = TEMPLATE
}

// #endregion